import { render, staticRenderFns } from "./StockEditSingle.vue?vue&type=template&id=2d460ba2"
import script from "./StockEditSingle.vue?vue&type=script&lang=ts"
export * from "./StockEditSingle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d460ba2')) {
      api.createRecord('2d460ba2', component.options)
    } else {
      api.reload('2d460ba2', component.options)
    }
    module.hot.accept("./StockEditSingle.vue?vue&type=template&id=2d460ba2", function () {
      api.rerender('2d460ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/StockEditSingle.vue"
export default component.exports